// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3x10u","modalFooterButton":"ModalNotes_modalFooterButton__3A0KY"};